module.exports = __webpack_public_path__ + "img/pax.d1170d33.png";